import React from "react";
import { Text } from "informed";
import FormMessage from "components/FormMessage";

export default ({ label, helpMessage, ...rest }) => {
  return (
    <div className="field">
      <label className="label">{label}</label>
      <p className="control">
        <Text className="input" {...rest} />
      </p>
      <FormMessage {...helpMessage} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/form-fields/InputText.js